import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderIconNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 62,
	height: 55,
	viewBox: "0 0 62 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M58 10C59.6569 10 61 11.3431 61 13V51C61 52.6569 59.6569 54 58 54H4C2.34315 54 1 52.6569 1 51V10H58Z",
		stroke: "#F5F5F5",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0 4C0 1.79086 1.79086 0 4 0H24.3293C25.6832 0 26.9452 0.684875 27.683 1.82005L33 10H0V4Z",
		fill: "#F5F5F5"
	})]
});
export default SvgFolderIconNew;
